import type { Breadcrumb } from '@/types'

export interface ItemListElement {
  '@type': string
  position: number
  name: string
  item: string
}
export interface BreadcrumbsLD {
  '@context': string
  '@type': string
  itemListElement: ItemListElement[]
}

const useBreadcrumbs = (
  trim = false,
  lastBreadcrumbText = '',
  capitalizeEachWord = false,
) => {
  const route = useRoute()
  const fullPath = route.fullPath.slice(1)
  const pathArray = fullPath.split('/').filter((path) => path)

  const langCodes = ['de']

  pathArray.forEach((path, index) => {
    if (langCodes.includes(path)) {
      pathArray.splice(index, 1)
    }
  })

  if (lastBreadcrumbText.length) {
    pathArray[pathArray.length - 1] = lastBreadcrumbText
  }
  let breadcrumbs: Breadcrumb[] = pathArray.map(
    (pathName: string, index: number) => {
      const currentPathArray = pathArray.slice(0, index + 1)
      let formattedName = pathName.replaceAll('-', ' ')

      if (capitalizeEachWord) {
        formattedName = formattedName.replace(/\b\w/g, (c) => c.toUpperCase())
      } else {
        formattedName =
          formattedName.charAt(0).toUpperCase() + formattedName.slice(1)
      }

      if (trim && formattedName.length > 30) {
        formattedName = formattedName.substring(0, 30) + '...'
      }

      const sanitizedUrlSpecialChars = ['?', '#']

      sanitizedUrlSpecialChars.forEach((char) => {
        if (formattedName.includes(char)) {
          formattedName = formattedName.substring(0, formattedName.indexOf(char))
        }
      })


      return {
        name: formattedName,
        fullPath: currentPathArray.join('/'),
        isLink: index !== pathArray.length - 1,
      }
    },
  )

  if (breadcrumbs.slice(-1)[0].name === '') {
    breadcrumbs = breadcrumbs.slice(0, -1)
  }

  const getBreadcrumbsJsonLd = (): BreadcrumbsLD => {
    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbs.map((breadcrumb, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: breadcrumb.name,
          item: `https://infermedica.com/${breadcrumb.fullPath}`,
        }
      }),
    }

    return jsonLd
  }

  return {
    breadcrumbs,
    getBreadcrumbsJsonLd,
  }
}

export default useBreadcrumbs
